import { PropTableValues } from "../../../../src/components";
import { Label } from '@primer/react';
import { Link } from 'gatsby';
import * as React from 'react';
export default {
  PropTableValues,
  Label,
  Link,
  React
};